/**
 * Return the browser user agent.
 *
 * @return {String}
 */
export default function userAgent () {
    return window.navigator.userAgent || window.navigator.vendor || window.opera;
}
